import React, { useEffect, useRef } from "react";
import { useDashboardContext } from "../../../contexts/dashboard-context";
import { useDefinition } from "../../../hooks/useDefinition";
import { useProductOptions } from "../../../hooks/useProductOptions";
import { useSelectedProductOption as useSelectedProductOptionCode } from "../../../hooks/useSelectedProductOption";
import { BottomMenuPanel } from "../../bottom-menu-panel";
import { BottomMenuButtons, IBottomMenuButtonsRef } from "../../bottom-menu/buttons";
import { ProductOption } from "./product-option";

import "./product-options-bottom-menu-panel.css";
import { useErrorHandling } from "../../../hooks/useErrorHandling";

export const ProductOptionsBottomMenuPanel = () => {
	const { createErrorHandler } = useErrorHandling();
	const dashboard = useDashboardContext();
	const { productOptionGroup } = useProductOptions();

	const productOptionCode = useSelectedProductOptionCode();

	const onClick = (option: eXpress.core.IProductOption) => {
		dashboard
			.changeProductOptionAsync(option && option.code ? option.code : undefined)
			.catch(createErrorHandler());
	};

	const definition = useDefinition();
	const rootCategory = definition?.product.categoryGroups.first();
	const bottomMenuRef = useRef<IBottomMenuButtonsRef>(null);
	const showPrice = productOptionGroup?.productOptions.values.some((p) => p.price);

	useEffect(() => {
		const index = productOptionGroup?.productOptions.values.findIndex(
			(value) => value.code === productOptionCode,
		);
		if (index !== undefined && index >= 0)
			bottomMenuRef.current?.scrollIntoView(index, { animate: false });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [productOptionGroup?.productOptions.values]);

	useEffect(() => {
		const index = productOptionGroup?.productOptions.values.findIndex(
			(value) => value.code === productOptionCode,
		);
		if (index !== undefined && index >= 0) {
			bottomMenuRef.current?.scrollIntoView(index);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [productOptionCode]);

	// CSS classes must be added to make icons possible (configured in a SASS from DC)
	// Eg: [data-product-category-group-code=wall_decoration] .product-options .product-option-element[data-alternative-option-group-code=blackframe]

	if (!productOptionGroup) return null;

	return (
		<BottomMenuPanel>
			<div
				data-product-category-group-code={rootCategory}
				className="deprecated-sass-icon-wrapper"
			>
				{/* Needed DC SASS icon placement */}
				<div className="product-options">
					{/* Needed DC SASS icon placement */}
					<BottomMenuButtons ref={bottomMenuRef}>
						{productOptionGroup?.productOptions.values.map((option) => {
							return (
								<ProductOption
									className="product-options--option"
									key={option.name}
									option={option}
									onClick={() => onClick(option)}
									optionGroupCode={productOptionGroup.code}
									isActive={option.code === productOptionCode}
									showPrice={showPrice}
									icon={option.icon}
								/>
							);
						})}
					</BottomMenuButtons>
				</div>
			</div>
		</BottomMenuPanel>
	);
};
